module.exports = __webpack_public_path__ + "img/08.7acae8e3.jpg";